

import React, { useEffect } from 'react';

//STEP 1:
//create components using React.lazy
const LightTheme = React.lazy(() => import('./mobile/Routers/AppRouter'));
const DarkTheme = React.lazy(() => import('./dtp/Router/AppRouter'));

//STEP 2:
//create a parent component that will load the components conditionally using React.Suspense
const ThemeSelector = ({ children }) => {
  
  let isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  return (
    <>
      <React.Suspense fallback={<></>}>
        {(isMobile === true) && <LightTheme />}
        {(isMobile === false) && <DarkTheme />}

      </React.Suspense>
      {children}
    </>
  )
}

const App = () => {
  return <ThemeSelector />

}

export default App;